import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/landing/site-header'
import SiteFooter from '@/components/landing/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col overflow-x-clip bg-background'>
            <a
                href='#main'
                className='sr-only z-[60] rounded-lg bg-white px-4 py-2 text-sm font-medium text-black focus:not-sr-only focus:fixed focus:top-4 focus:left-4'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
